module.exports = __webpack_public_path__ + "img/parter-avatar9.d6b95fef.png";